import { IAuthenticationProvider, AuthEnvironment, UIAuthProvider } from "../../interfaces/IAuthenticationProvider";
import { AuthSharedComponent } from "./AuthSharedComponent";
import { AuthErrors, AuthError } from './AuthErrors';
import { ErrorStringFromException } from "../../../utils/utils";

/*
    USNAT stands for "USNAT High security environment".
*/
export class USNATAuthenticationProvider implements IAuthenticationProvider {
    private authSharedComponent: AuthSharedComponent = new AuthSharedComponent();

    Authenticate(): void {

        OfficeFirstPartyAuth.debugging = true;
        OfficeFirstPartyAuth.authorityOverride = "https://login.microsoftonline.eaglex.ic.gov";

        try {
            this.authSharedComponent.Authenticate();
        } catch (error) {
            throw new AuthError(AuthErrors.UnableToAuthenticate, ErrorStringFromException(error));
        }
    }

    async GetAccessToken(resource: string): Promise<string> {
        try {
            return await this.authSharedComponent.GetAccessToken(resource);
        } catch (error) {
            throw new AuthError(AuthErrors.UnableToFetchToken, ErrorStringFromException(error));
        }
    }

    GetAuthEnvironment(): AuthEnvironment {
        return AuthEnvironment.USNAT;
    }

    SetUIAuthProvider(uiAuthProvider: UIAuthProvider): void {
        this.authSharedComponent.SetUIAuthProvider(uiAuthProvider);
    }
}